// extracted by mini-css-extract-plugin
export default {"clientMenuContainer":"ClientMenuIconStyles_clientMenuContainer__eQunZ","clientMenuIcon":"ClientMenuIconStyles_clientMenuIcon__K94bP"};